import { Pagination } from 'react-admin';

export const MyPagination = props => <Pagination rowsPerPageOptions={[10, 20, 50, 100]} {...props} />;
